export default __webpack_public_path__ + "static/media/chest.64b37833.jpg";